/**
 * @copyright    Copyright © 2019-2025 MiniVentureLab
 * @author       Alok Pabalkar  <alok@miniventurelab.com>
 * @package      Mesh Platform UI
 * @license      Proprietary
 * @description  Console
 * 
 * Handle Logout Functionality
 */
import iosBridge from '../store/ios_bridge'
import store from './store';
const firebase = require('firebase/app');
require('firebase/auth');

var logout = {

/**
  * mesh_logout
  * Log the Gide User out
  */
async mesh_logout(){
  store.dispatch("destroyLocalStore");
},
/**
  * logout
  * Log the User out
  */
async logout(error){
  let app_version = parseInt(store.getters.getAppVersion);

  if (process.env.VUE_APP_DEBUG == "true"){console.log("logout=> XXXX",error);}
  store.dispatch("destroyLocalStore");

  if (firebase.apps.length) {
    await this.firebase_signout();
  }

  //Remove the user_id from the APP's preferences.
  if(window.androidBridge){
    window.androidBridge.clearAppStorage();
  }
  else if(window.webkit){
    iosBridge.sendMessage({"module":"clearAppStorage"});    
  }

  store.commit('setAppVersion', app_version);

  //Google API - Used by Calendar, GMAIL
  if(window.gapi){
    if(window.gapi.auth2 && window.gapi.auth2.getAuthInstance()){
      window.gapi.auth2.getAuthInstance().signOut();
    }
  }

  //Add external routes here as we dont want to reload the same page
  if(window.location.href.indexOf("/activate") !== -1){
    window.location.href = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port : '')+'/#/login'
  }
  else{
    window.location.reload();  
  }  
},
/**
  * firebase_signout
  * Log the User out of firebase
  */
firebase_signout(){
  return new Promise((resolve, reject)=>{
    try{
      firebase.auth().signOut()
      .then(function() {
        if(process.env.VUE_APP_DEBUG){console.log('Firebase Sign out');}
        resolve(true);
      })
      .catch(function(error) {
        if(process.env.VUE_APP_DEBUG){console.log('Error: Firebase Sign out', error);}
        reject();
      });  
    }
    catch(error){
      if (process.env.VUE_APP_DEBUG == "true"){console.log("firebase_signout=>",error);}
      reject();
    }
  })
}

};/*End of request Object */

export default logout;
